import "./allStoreCanvas.scss";
import pluralize from "pluralize";
import { useDispatch } from "react-redux";
import { Offcanvas } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Loading from "../../../../../../common/Loading";
import Slider3 from "../../../../../../common/Slider/Slider3";
import { isAdvancedCashback } from "../../../../Loyalty/Edit/utils";
import { getFullImageUrl } from "../../../../../../../utils/constants/constants";
import { getPublicLoyalty } from "../../../../../../../redux/actions/qrCodeActions";
import LoyaltyFinalCreative from "../../../../Loyalty/Edit/components/LandingPages/LoyaltyFinalCreative";
import AdvancedLoyaltyFinalCreative from "../../../../Loyalty/Edit/components/LandingPages/AdvancedLoyaltyFinalCreative";

const AllStoresCanvas = ({
  data,
  isOpen,
  pointsObj,
  customerName,
  toggleCanvas,
  isShortlink = false,
}) => {
  const [isLoyaltyCanvas, toggleLoyaltyCanvas] = useState(false);
  const [state, setState] = useState({ storeId: "", storeName: "" });

  return (
    <>
      <Offcanvas
        show={isOpen}
        placement="bottom"
        onHide={toggleCanvas}
        className="all-store-canvas"
      >
        <Offcanvas.Body>
          <div className="canvas-header">
            <span onClick={toggleCanvas}>
              <img src="/assets/icons/arrow-down.svg" alt="back" /> Back
            </span>
          </div>
          <div className="canvas-body">
            <div
              className="card-logo-div"
              style={{
                backgroundColor: data.text_color,
              }}
            >
              {data?.logo ? (
                <img
                  alt="card-logo"
                  title={data.storeName}
                  className="card-logo-image"
                  src={getFullImageUrl(data?.logo)}
                />
              ) : (
                <p
                  className="card-logo-name"
                  style={{ color: data.theme_color }}
                >
                  {data.storeName}
                </p>
              )}
            </div>
            {data?.rewardType === "loyalty" ? (
              <>
                <h6 style={{ marginBottom: "0" }}>Redeem at any store below</h6>
                <p style={{ marginTop: "8px" }}>
                  Select a store to see their loyalty program
                </p>
              </>
            ) : (
              <h6>Visit any of our store below</h6>
            )}
            {data?.rewardType === "loyalty"
              ? data?.allStoresArr?.map((store, i) => (
                  <div
                    key={i}
                    className="store-row"
                    onClick={() => {
                      setState({
                        storeName: store?.name,
                        storeId: store?._id || store?.id,
                      });
                      toggleLoyaltyCanvas(!isLoyaltyCanvas);
                    }}
                  >
                    <p>{store?.name}</p>
                    <img src="/assets/icons/arrow-right.svg" alt="arrow" />
                  </div>
                ))
              : data?.allStoresArr?.map((store, i) => (
                  <p key={i}>{store?.name}</p>
                ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <LoyaltyCanvas
        pointsObj={pointsObj}
        storeId={state.storeId}
        isOpen={isLoyaltyCanvas}
        isShortlink={isShortlink}
        storeName={state.storeName}
        customerName={customerName}
        toggleCanvas={() => toggleLoyaltyCanvas(!isLoyaltyCanvas)}
      />
    </>
  );
};

export default AllStoresCanvas;

const LoyaltyCanvas = ({
  isOpen,
  storeId,
  storeName,
  pointsObj,
  isShortlink,
  toggleCanvas,
  customerName,
}) => {
  const dispatch = useDispatch();
  const [isLoading, toggleLoading] = useState(false);
  const [loyaltyData, setLoyaltyData] = useState({});

  useEffect(() => {
    // fetch loyalty data and set locally
    if (storeId) {
      toggleLoading(true);
      dispatch(getPublicLoyalty(storeId))
        .then((payload) => {
          toggleLoading(false);
          setLoyaltyData(payload);
        })
        .catch(() => toggleLoading(false));
    }
  }, [storeId, dispatch]);

  const isShowRedeemCard =
    pointsObj?.current_points > 0 && loyaltyData?.type !== "cashback";
  const pointsBranding = loyaltyData?.settings?.points_branding;
  const totalRedeemableRewards = loyaltyData?.rewards?.filter(
    (reward) =>
      reward?.is_active && reward?.points_value <= pointsObj?.current_points
  )?.length;

  const isAdvCbCreative =
    loyaltyData?.type === "cashback" &&
    isAdvancedCashback(loyaltyData?.settings?.advanced_cashback?.type);

  return (
    <Offcanvas
      show={isOpen}
      placement="bottom"
      onHide={toggleCanvas}
      className="store-loyalty-canvas"
    >
      <Offcanvas.Body>
        <div className="canvas-header">
          {storeName}
          <img
            alt="close"
            onClick={toggleCanvas}
            src="/assets/icons/close-2.svg"
          />
        </div>
        <div className="canvas-body">
          {isLoading ? (
            <Loading />
          ) : (
            <>
              {isShowRedeemCard && (
                <>
                  {totalRedeemableRewards > 0 ? (
                    <div className="qr-redeemable-reward-div">
                      <div className="show-available-points">
                        <span>Hello {customerName},</span>
                        <span>
                          You have{" "}
                          <b>
                            {pointsObj?.current_points}{" "}
                            {pluralize(
                              pointsBranding?.active
                                ? pointsBranding?.name
                                : "points",
                              pointsObj?.current_points
                            )}
                          </b>
                        </span>
                      </div>

                      <div className="show-total-rewards">
                        <img
                          src="/assets/images/qr/others/unlock.svg"
                          alt="unlock"
                        />
                        <span>
                          {totalRedeemableRewards}{" "}
                          {pluralize("Rewards", totalRedeemableRewards)}{" "}
                          Unlocked 🎉
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="qr-non-redeemable-rewards-div">
                      <p>
                        You're{" "}
                        <b>
                          {loyaltyData?.rewards?.[0]?.points_value -
                            pointsObj?.current_points}{" "}
                          {pluralize(
                            pointsBranding?.active
                              ? pointsBranding?.name
                              : "points",
                            pointsObj?.current_points
                          )}
                        </b>{" "}
                        away from your first reward
                      </p>
                      {pointsObj?.current_points <=
                        loyaltyData?.rewards?.[0]?.points_value && (
                        <div className="slider-row">
                          <Slider3
                            min={0}
                            step={1}
                            isDisabled={true}
                            setValue={() => {}}
                            value={pointsObj?.current_points}
                            max={loyaltyData?.rewards?.[0]?.points_value}
                          />
                          <img
                            alt="star"
                            className="star"
                            src="/assets/images/qr/others/star.svg"
                          />
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
              {isAdvCbCreative ? (
                <AdvancedLoyaltyFinalCreative
                  pointsObj={pointsObj}
                  storeName={storeName}
                  isShortlink={isShortlink}
                  loyaltyData={loyaltyData}
                />
              ) : (
                <LoyaltyFinalCreative
                  pointsObj={pointsObj}
                  storeName={storeName}
                  isShortlink={isShortlink}
                  loyaltyData={loyaltyData}
                />
              )}
            </>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
